import { Component, OnInit, AfterViewInit } from '@angular/core';
import { TranslateService } from '../../services/translate.service';
import { AuthenticationService } from '../../services/authentication.service';
import { NaviService } from '../../services/navi.service';
import { BasicError } from '../..//models/error/error';
import { ProfileService } from '../../services/profile.service';
declare var $: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, AfterViewInit {
  public username: String = '';
  public password: String = '';
  public noUsername: String = 'no username';
  public noUsernameCheck: Boolean = false;
  public noPassword: String = 'no password';
  public noPasswordCheck: Boolean = false;
  public loginFailed: Boolean = false;
  public loginFailedText: String = 'login failed';

  public registrationUrl: String = 'registration';
  public forgotpasswordUrl: String = 'forgot-password';

  // TinnitusCare Logo
  public imgLogo: String = 'assets/img/tinnituscare.png';
  public landingpageUrl: String = '/';

  constructor(private translate: TranslateService, private authentication: AuthenticationService, private naviService: NaviService,
    private profile: ProfileService) {
    this.noUsername = this.translate.translate(this.noUsername.toString()); // Translating the variable
    this.noPassword = this.translate.translate(this.noPassword.toString()); // Translating the variable
  }

  ngOnInit() {
  }

  ngAfterViewInit() {

    const self = this;

    $(document).ready(function () {
      $('#login1, #login2').on('keydown', function (e) {
        if (e.which === 13) {
          self.login();
        }
      });
    });

  } // ngAfterView end

  public login(): void {
    // Check if username and password are given display message
    if (this.username.length < 2) {
      this.noUsernameCheck = true;
    } else {
      this.noUsernameCheck = false;
    }

    if (this.password.length < 2) {
      this.noPasswordCheck = true;
    } else {
      this.noPasswordCheck = false;
    }

    // Abort if password or username wasn't entered
    if (this.password.length < 2 || this.username.length < 2) {
      return;
    }

    // Try to authenticate given user with entered credentials
    this.authentication.login(this.username, this.password).subscribe(data => {
      // Check for Error first
      if (data instanceof BasicError) {
        this.loginFailed = true;
        return;
      }

      // Check if user could be fetched
      if (data === null) {
        console.log('No profile could be fetched.');
      }

      // Decide if dashboard or hcpdashboard should be loaded
      this.profile.getMyRoles().subscribe(roles => {
        if (roles instanceof Array && roles.length > 0) {
          // Go directly to hcpdashboard
          this.naviService.setCurrentPage('hcpdashboard');
        } else {
          this.naviService.setCurrentPage('dashboard');
        }
      });
    });
  }

  public navigateToRegistration() {
    this.naviService.navigateToUrl(this.registrationUrl, 'registration');
  }

  public navigateToForgotPassword() {
    this.naviService.navigateToUrl(this.forgotpasswordUrl, 'forgot-password');
  }

  public navigateToLandingPage() {
    this.naviService.navigateToUrl(this.landingpageUrl, '');
  }
}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/login/login.component.ts